import { Action, createReducer, on } from "@ngrx/store";
import * as ordersActions from './orders.actions';
import * as quotationsActions from 'src/app/features/quotations/store/quotations.actions';
import { IOrder, IOrderKPI, IOrdersFilterState } from "../models/order.model";
import { refillOrdersFilter } from "src/app/shared/utils/helpers";
import { IPagination } from "src/app/shared/models/page.model";

export interface ordersState {
  orders: IOrder[],
  kpi: IOrderKPI | undefined
  loading: boolean
  ordersFilterState: IOrdersFilterState;
  metadata: IPagination | null;
  showProcessing: boolean;
}

export const initialordersState: ordersState = {
  orders: [],
  kpi: undefined,
  loading: false,
  ordersFilterState: {
    advanced: refillOrdersFilter(),
    keyword: ''
  },
  metadata: null,
  showProcessing: true,
}

const featureReducer = createReducer(
  initialordersState,
  on(
    ordersActions.GetOrdersSuccess,
    (state, action) => ({
      ...state,
      orders: action.res.object?.orders || state.orders,
      kpi: action.res.object?.kpi,
      metadata: action.res.metadata
    })
  ),
  on(
    ordersActions.SetOrdersLoader,
    (state, action) => ({
      ...state,
      loading: action.isLoading
    })),
  on(ordersActions.SetOrdersFilter, (state, action) => ({
    ...state,
    ordersFilterState: {
      advanced: action.advanced!,
      keyword : action.keyword
    }
  })),
  on(ordersActions.SetOrdersSearch, (state, action) => ({
    ...state,
    ordersFilterState: {
      ...state.ordersFilterState,
      searchOrders: action.search
    }
  })),
    on(ordersActions.exportOrders, (state) => ({
      ...state,
      loading: true,
    })),
    on(ordersActions.exportOrdersSuccess, (state) => ({
      ...state,
      loading: false,
    })),
    on(ordersActions.ToggleProcessingVisibility, (state) => ({
      ...state,
      showProcessing: !state.showProcessing,
    })),
    on(ordersActions.SetProcessingVisibility, (state, action) => ({
      ...state,
      showProcessing: action.visible,
    })),
    // WB-8066: the side-by-side panel (matching/unmatching a line, its primary
    // action) always dispatches this quotations-store action regardless of
    // whether it was opened from /orders or /quotations -- see
    // side-by-side-correction-panel.component.ts's `quotationInStore`. Without
    // this, the orders list row behind the panel kept showing the pre-match
    // counts until the list was manually refetched.
    on(quotationsActions.UpdateQuotationLinesSuccess, (state, action) => {
      const summary = action.delta.summary;
      return {
        ...state,
        orders: state.orders.map((o) =>
          o.id === action.orderId
            ? {
                ...o,
                nbr_products: summary.nbr_products,
                total_skus: summary.total_skus,
                total_qty: summary.total_qty,
                amount_total: summary.amount_total,
                line_composition: summary.line_composition ?? o.line_composition,
              }
            : o
        ),
      };
    }),
)

export function ordersReducer(state: ordersState | undefined, action: Action) {
  return featureReducer(state, action);
}
